module.exports = __webpack_public_path__ + "static/media/Frame.e870890f.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/v2/workshop/Frame.png
// module id = 600
// module chunks = 2